import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './DifferentialSection.module.scss';

export const DifferentialSection: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className={styles['section-open']} id="differential">
            <div className={styles['container']}>
                <div className={styles['card']}>
                    <div className={styles['col-left']}>
                        <p className={styles['eyebrow']}>
                            {t('landing.differential.eyebrow', 'DIFERENCIAL')}
                        </p>
                        <h2 className={styles['title']}>
                            {t('landing.differential.title', 'Una integración entendida como interacción real')}
                        </h2>
                        <p className={styles['subtitle']}>
                            {t('landing.differential.subtitle', 'Por eso, más que ordenar profesionales en categorías, buscamos tender puentes entre saberes, experiencias y formas de acompañar la salud.')}
                        </p>
                    </div>
                    <div className={styles['col-right']}>
                        <p className={styles['description']}>
                            {t('landing.differential.description', 'En Bodhiwell, la integración no se entiende como una simple convivencia entre disciplinas, sino como la posibilidad concreta de interacción entre miradas distintas. Creemos que cuando diferentes enfoques pueden dialogar con respeto, criterio y apertura, también se amplía la forma de comprender a la persona y de acompañar sus procesos.')}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};
